import { Dispatch, SetStateAction } from "react";
import { Biobox } from "../../../../types";
import { Autoclave, OpenAssignBoxModal } from "../types";
import { Box } from "@mui/material";

interface AssignedBioboxes {
  autoclave: Autoclave,
  bioboxes: Biobox[];
  setOpenAssignBioboxModal: Dispatch<SetStateAction<OpenAssignBoxModal>>;
}

const AssignedBioboxes = (props: AssignedBioboxes) => {
  const { autoclave, bioboxes, setOpenAssignBioboxModal } = props

  const handleAssignBox = (biobox: Biobox) => {
    setOpenAssignBioboxModal({open: true, autoclave, biobox})
  }

  return (
    <Box sx={{ padding: '0 16px 16px 16px', fontSize: '13px' }}>
      {
        bioboxes.map((box) => (
          <Box key={box.box_id} className="flex" columnGap="4px">
            <span>Assigned Spore Test Box Number</span>
            <span
              className='text-link'
              onClick={() => handleAssignBox(box)}
            >
              {box.box_number}
            </span>
          </Box>
        ))
      }
    </Box>
  )
}

export default AssignedBioboxes
